import { RefObject, UIEventHandler, useEffect, useState } from 'react';
import { useResizeObserver } from 'react-aria/private/utils/useResizeObserver';

export function useHasOverflow<T extends HTMLElement>({
  threshold = 5,
  ref,
}: {
  threshold?: number;
  ref: RefObject<T>;
}): {
  onScroll: React.UIEventHandler<T>;
  hasOverflow: {
    left: boolean;
    right: boolean;
  };
} {
  const [hasOverflow, setHasOverflow] = useState({
    left: false,
    right: false,
  });

  const update = () => {
    const element = ref.current;
    if (element) {
      const offsetLeft = element.scrollLeft;
      const offsetRight =
        element.scrollWidth - (element.offsetWidth + element.scrollLeft);
      const newHasOverflow = {
        left: offsetLeft >= threshold,
        right: offsetRight >= threshold,
      };
      if (
        hasOverflow.left !== newHasOverflow.left ||
        hasOverflow.right !== newHasOverflow.right
      ) {
        setHasOverflow(newHasOverflow);
      }
    }
  };

  useResizeObserver({
    ref,
    onResize: update,
  });

  useEffect(update, []);

  return {
    onScroll: update as UIEventHandler<T>,
    hasOverflow,
  };
}
